import PremiumDashboard from "views/PremiumDashboard.js";
import UserProfile from "views/UserProfile.js";
import Transaction from "views/Transaction.js";
import Subscription from "views/Subscription.js";
import NewsFeed from "views/NewsFeed.js";
import Goals from "views/Goals.js";
import Scan from "views/Scan.js";
import Wallet from "views/Wallet.js";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Overview",
    icon: "fas fa-chart-pie",
    component: PremiumDashboard,
    layout: "/admin",
  },
  {
    path: "/wallet",
    name: "Transactions",
    icon: "fas fa-wallet",
    component: Wallet,
    layout: "/admin",
  },
  {
    path: "/scan",
    name: "Scan Receipts",
    icon: "fas fa-camera",
    component: Scan,
    layout: "/admin",
  },
  {
    path: "/subscription",
    name: "Subscriptions",
    icon: "fas fa-credit-card",
    component: Subscription,
    layout: "/admin",
  },
  {
    path: "/goals",
    name: "Goals",
    icon: "fas fa-bullseye",
    component: Goals,
    layout: "/admin",
  },
  {
    path: "/news",
    name: "Financial News",
    icon: "fas fa-newspaper",
    component: NewsFeed,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "Profile",
    icon: "fas fa-user-circle",
    component: UserProfile,
    layout: "/admin",
  },
];

export default dashboardRoutes;
